var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgControl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M72.094,46h-31.59c-0.843-2.566-3.259-4.426-6.103-4.426s-5.26,1.86-6.103,4.426h-4.392c-1.104,0-2,0.896-2,2s0.896,2,2,2 h4.392c0.843,2.566,3.259,4.426,6.103,4.426s5.26-1.86,6.103-4.426h31.59c1.104,0,2-0.896,2-2S73.198,46,72.094,46z M34.4,50.426 c-1.337,0-2.426-1.088-2.426-2.426c0-1.337,1.088-2.426,2.426-2.426s2.426,1.088,2.426,2.426 C36.826,49.338,35.738,50.426,34.4,50.426z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.906,35.478h31.907c0.843,2.566,3.258,4.426,6.103,4.426s5.26-1.86,6.103-4.426h4.075c1.104,0,2-0.896,2-2s-0.896-2-2-2 h-4.075c-0.843-2.566-3.259-4.426-6.103-4.426s-5.26,1.86-6.103,4.426H23.906c-1.104,0-2,0.896-2,2S22.801,35.478,23.906,35.478z  M61.916,31.052c1.338,0,2.426,1.088,2.426,2.426c0,1.338-1.088,2.426-2.426,2.426s-2.426-1.088-2.426-2.426 C59.49,32.141,60.578,31.052,61.916,31.052z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.094,60.521h-8.501c-0.843-2.566-3.259-4.426-6.103-4.426s-5.26,1.86-6.103,4.426H23.906c-1.104,0-2,0.896-2,2 s0.896,2,2,2h27.482c0.843,2.566,3.259,4.426,6.103,4.426s5.26-1.86,6.103-4.426h8.501c1.104,0,2-0.896,2-2 S73.198,60.521,72.094,60.521z M57.49,64.947c-1.338,0-2.426-1.088-2.426-2.426s1.088-2.426,2.426-2.426s2.426,1.088,2.426,2.426 S58.828,64.947,57.49,64.947z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControl);
export default __webpack_public_path__ + "static/media/control.b2b28d98ecd7501e3f8682e6a29505d8.svg";
export { ForwardRef as ReactComponent };